import React, { useEffect, useState } from "react";
import {
  fetchAcademicsBanner,
  fetchAcademicsOverview,
  fetchAcademicCategories,
  fetchAcademicPrograms, fetchAcademicPageSeo
} from "../Adapter/PageAdapter";
// import useSeo from "../hooks/useSeo";
// import SeoHelmet from "../components/SeoHelmet";
import { Helmet } from "react-helmet-async";
import { Tab, Nav } from "react-bootstrap";
import AcademicsBan from "../assets/images/Academic.jpg";
import acadRight from "../assets/images/acaderght.png";
import doctorTab from "../assets/images/doctortab.png";
import nurseTab from "../assets/images/nursetab.png";
import arrSvg from "../assets/images/arrw.svg";
import { baseImage_path } from "../variables/Variables";
import { stripHtmlForMeta } from "../utils/seoMetaText";
import { NavLink } from "react-router-dom";

// const BASE_IMAGE_URL = "http://localhost/slraheja/sl-raheja/public";

const Academics = () => {
  const [activeTab, setActiveTab] = useState("doctors");
  const [bannerData, setBannerData] = useState(null);
  const [overviewData, setOverviewData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    const loadSeo = async () => {
      try {
        console.log("Calling fetchAcademicPageSeo...");
        const res = await fetchAcademicPageSeo();
        console.log("API Response:", res);
        if (res && res.data) {
          setSeoData(res.data);
        }
      } catch (e) {
        console.error("Direct SEO fetch failed:", e);
      }
    };

    loadSeo();
  }, []);

  // const seoData = useSeo(fetchAcademicPageSeo);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const bannerResponse = await fetchAcademicsBanner();
        setBannerData(bannerResponse.data);

        // Fetch Academics Overview
        const overviewResponse = await fetchAcademicsOverview();
        setOverviewData(overviewResponse.data);

        // Fetch Categories (Doctors / Nurses)
        const categoryResponse = await fetchAcademicCategories();
        console.log("here is category", categoryResponse);
        if (categoryResponse?.data) {
          setCategories(categoryResponse.data);
          setActiveTab(categoryResponse.data[0].id.toString()); // Set first tab as active by default
          fetchPrograms(categoryResponse.data[0].id); // Fetch programs for first category
        }
      } catch (error) {
        console.error("Error fetching data for Academics page:", error);
      }
    };

    fetchData();
  }, []);

  const fetchPrograms = async (categoryId) => {
    try {
      const response = await fetchAcademicPrograms(categoryId);
      if (response?.data) {
        setPrograms(response.data);
      }
    } catch (error) {
      console.error("Error fetching programs:", error);
    }
  };

  const handleTabChange = (categoryId) => {
    if (activeTab !== categoryId) {
      setActiveTab(categoryId);
      fetchPrograms(categoryId);
    }
  };

  const handleMailTo = (e) => {
    e.preventDefault(); // Prevents `NavLink` from trying to route
    window.location.href = "mailto:slrh.academics@rahejahospital.com";
  };

  return (
    <>
      {/* {seoData && <SeoHelmet seoData={seoData} />} */}
      {seoData && (
        <Helmet>
          <title>{seoData.seo_title}</title>
          <meta name="title" content={seoData.meta_title} />
          <meta name="description" content={stripHtmlForMeta(seoData.meta_description)} />
          <meta name="keywords" content={seoData.meta_keywords} />

          <meta property="og:title" content={seoData.og_title} />
          <meta property="og:description" content={stripHtmlForMeta(seoData.og_description)} />
          <meta property="og:type" content={seoData.og_type} />
          <meta property="og:url" content={seoData.og_url} />
          <meta property="og:image" content={`${baseImage_path}/${seoData.og_image}`} />
          <meta property="og:locale" content={seoData.og_locale} />
          <meta property="og:site_name" content={seoData.og_site_name} />
          <meta property="article:modified_time" content={seoData.article_modified_time} />

          <meta name="twitter:card" content={seoData.twitter_card} />
          <meta name="twitter:title" content={seoData.twitter_title} />
          <meta name="twitter:description" content={stripHtmlForMeta(seoData.twitter_description)} />
          <meta name="twitter:image" content={`${baseImage_path}/${seoData.twitter_image}`} />
          <meta name="twitter:site" content={seoData.twitter_site} />

          <link rel="canonical" href={seoData.canonical_link} />

          {/* Custom scripts injection */}
          {seoData.custom_scripts && (
            <script type="text/javascript" dangerouslySetInnerHTML={{ __html: seoData.custom_scripts }} />
          )}
        </Helmet>
      )}

      {/* Banner Section */}
      <section className="banner-spac">
        <div className="cust-container">
          <div className="banner-box">
            {bannerData && bannerData.img_path ? (
              <img
                src={`${baseImage_path}${bannerData.img_path.replace(
                  /^\./,
                  ""
                )}`}
                alt="Academics Banner"
              />
            ) : (
              <img src={AcademicsBan} alt="Default Banner" />
            )}
            <div className="ban-con">
              <h1>Academics</h1>
            </div>
          </div>
        </div>
      </section>

      {/* Academics Overview Section */}
      <section className="academics-sec academic-sec-top-pad">
        <div className="cust-container">
          <div className="academics-sec-inner">
            <div className="row align-items-center">
              <div className="col-lg-5 col-xl-5 col-md-6 col-sm-12 col-12">
                <div className="finnest host-det mobtopmarg careerjoininner academics-secdesc">
                  <h4>
                    <span>{overviewData?.heading || "Academics"}</span>
                  </h4>
                  <p className="ck-content" dangerouslySetInnerHTML={{
                    __html: overviewData?.content || "S.L. Raheja Hospital - A Fortis Associate, is indeed a prominent name in tertiary care, excelling in patient care and providing world-class treatments across various specialties. In addition to its clinical expertise, the hospital is actively involved in medical education and training.",
                  }} />
                </div>
              </div>
              <div className="col-lg-7 col-xl-7 col-md-6 col-sm-12 col-12">
                <div className="academics-rght-img">
                  <img src={acadRight} alt="Academics Right" />
                  {/* <img
                    src={
                      overviewData?.side_img
                        ? `${baseImage_path}/${overviewData.side_img.replace(/^\./, "")}`
                        : `${baseImage_path}/images/academics-overview.png`
                    }
                    alt="Academics Right"
                  /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Academic Programs Section */}
      <section className="academics-docnurse-sec mrgntop70 margnbot90">
        <div className="cust-container">
          <div className="academics-docnurse-inner">
            <div className="academics-docnurse-head text-center">
              <p style={{ fontWeight: "bold", color: "#444F6F" }}>
                Here are some of the academic programs conducted at the
                hospital:
              </p>
            </div>

            <div className="academics-docnurse-tabs">
              <Tab.Container
                // defaultActiveKey="doctors"
                className="justify-content-center academic-ul"
                activeKey={activeTab}
                onSelect={handleTabChange}
              >
                <Nav
                  variant="pills"
                  className="mb-3 justify-content-center academic-ul"
                  style={{ gap: "20px", color: "#000000" }}
                >
                  {categories.map((category) => (
                    <Nav.Item key={category.id}>
                      <Nav.Link
                        eventKey={category.id.toString()}
                        className={`${activeTab === category.id.toString() ? "active" : ""
                          } ${category.category_name.toLowerCase().includes("nurse")
                            ? "nursecls"
                            : "doccls"
                          }`}
                        onClick={() => {
                          setActiveTab(category.category_name.toString());
                          fetchPrograms(category.id);
                        }}
                      >
                        <div className="academics-docnurse-tabs-icn">
                          <img
                            src={
                              category.category_name
                                .toLowerCase()
                                .includes("nurse")
                                ? nurseTab
                                : doctorTab
                            }
                            alt={`${category.name} Tab`}
                          />
                        </div>
                        <span>For {category.category_name}</span>
                      </Nav.Link>
                    </Nav.Item>
                  ))}

                  {/* <Nav.Item>
                    <Nav.Link
                      eventKey="doctors"
                      className={`doccls ${
                        activeTab === "doctors" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("doctors")}
                    >
                      <div className="academics-docnurse-tabs-icn">
                        <img src={doctorTab} alt="Doctors Tab" />
                      </div>
                      <span>For Doctors</span>
                    </Nav.Link>
                  </Nav.Item> */}

                  {/* <Nav.Item>
                    <Nav.Link
                      eventKey="nurses"
                      className={`nursecls ${
                        activeTab === "nurses" ? "active" : ""
                      }`}
                      onClick={() => setActiveTab("nurses")}
                    >
                      <div className="academics-docnurse-tabs-icn">
                        <img src={nurseTab} alt="Nurses Tab" />
                      </div>
                      <span>For Nurses</span>
                    </Nav.Link>
                  </Nav.Item> */}
                </Nav>

                {/* <Tab.Content>
                  {categories.map((category) => (
                    <Tab.Pane
                      eventKey={category.id.toString()}
                      key={category.id}
                    >
                      <p className="text-bold fw-bold">{`For ${category.program_name}:`}</p>
                      <ul className="course-list">
                        {programs.map(
                          (item) =>
                            item.academic_program_category_id.toString() ===
                              category.id.toString() && (
                              <li key={item.id} className="course-item">
                                {item.program_name}
                              </li>
                            )
                        )}
                      </ul>
                    </Tab.Pane>
                  ))}
                </Tab.Content> */}

                <Tab.Content>
                  {categories.map((category) => (
                    <Tab.Pane
                      eventKey={category.id.toString()}
                      key={category.id}
                    >
                      <p className="text-bold fw-bold">{`For ${category.category_name}:`}</p>
                      <ul className="course-list">
                        {programs
                          .filter(
                            (item) =>
                              item.academic_program_category_id.toString() ===
                              category.id.toString()
                          )
                          .map((item) => (
                            <li key={item.id} className="course-item">
                              {item.program_name}
                            </li>
                          ))}
                      </ul>
                    </Tab.Pane>
                  ))}
                </Tab.Content>

                <Tab.Content>
                  <Tab.Pane eventKey="doctors">
                    <p className="text-blod fw-bold">For Doctors:</p>
                    <ul className="course-list">
                      {programs.map(
                        (item) =>
                          item.academic_program_category_id === 1 && (
                            <li key={item.id} className="course-item">
                              {item.program_name}
                            </li>
                          )
                      )}
                      {/* <li className="course-item">DNB in Internal Medicine</li>
                      <li className="course-item">
                        Masters in Emergency Medicine by SEMI (Society for
                        Emergency Medicine India)
                      </li>
                      <li className="course-item">
                        Indian Diploma in Critical Care Medicine (IFCCM)
                      </li>
                      <li className="course-item">
                        Certificate in Critical Medicine (ISCCM)
                      </li>
                      <li className="course-item">
                        Fellowship in Diabetic Foot Surgery (Recognized by MUHS)
                      </li>
                      <li className="course-item">
                        Fellowship in Critical Care Medicine (Recognized by
                        MUHS)
                      </li>
                      <li className="course-item">
                        International Diabetic Federation’s Certificate Course
                        in Diabetology
                      </li>
                      <li className="course-item">
                        Critical Care Nutrition Course by ISPEN
                      </li>
                      <li className="course-item">
                        Fellowship in Diabetology by RSSDI (Research Society for
                        the Study of Diabetes in India)
                      </li> */}
                    </ul>
                  </Tab.Pane>

                  <Tab.Pane eventKey="nurses">
                    <p className="text-bold text-blod2 fw-bold text-blod2">
                      For Nurses:
                    </p>
                    <ul className="course-list">
                      {programs.map(
                        (item) =>
                          item.academic_program_category_id === 2 && (
                            <li key={item.id} className="course-item">
                              {item.program_name}
                            </li>
                          )
                      )}
                      {/* <li className="course-item">
                        Indian Diploma in Critical Care Nursing
                      </li>
                      <li className="course-item">
                        Fellowship in Critical Care Nursing
                      </li>
                      <li className="course-item">
                        Operation Theatre Nursing Program
                      </li> */}
                    </ul>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
            <div
              className="jdapplybtn d-flex justify-content-center"
              style={{ marginTop: "60px" }}
            >
              <NavLink
                to="#"
                className="btn with-color with-arr enqColor"
                onClick={handleMailTo}
              >
                <img src={arrSvg} alt="Arrow" /> Enquire Now
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Academics;
